module.exports = __webpack_public_path__ + "img/class2.a4507266.png";